import { ANALYTICS_EVENTS, ANALYTICS_MODULES } from './events';
import { trackEvent } from './index';
import * as quickUploadActions from '../containers/quick-upload/actions';
import * as studentRollActions from '../containers/student-roll/actions';
import * as teacherRollActions from '../containers/teacher-roll/actions';
import * as editStudentActions from '../containers/edit-student/actions';
import * as editTeacherActions from '../containers/edit-teacher/actions';
import * as assignUserActions from '../containers/assign-user/actions';
import * as manageDefaultCourseActions from '../containers/manage-default-courses/actions';
import * as manageAssignedCourseActionTypes from '../containers/manage-assigned-courses/action-types';
import * as rollOverActions from '../containers/roll-over/actions';

function trackSchoolRollEvent(track, name, props = {}) {
    track(name, props);
}

export default function createAnalyticsMiddleware(track = trackEvent) {
    let lastRolloverType = '';

    return () => next => (action) => {
        if (action.type === rollOverActions.ON_ROLLOVER_CONFIRMATION_REQUEST) {
            lastRolloverType = action.rolloverType;
        }

        const result = next(action);
        switch (action.type) {
        case quickUploadActions.QUICK_UPLOAD_TEMPLATE_SUCCESS:
            trackSchoolRollEvent(track, ANALYTICS_EVENTS.actionCompleted, {
                action: 'upload',
                module: ANALYTICS_MODULES.quickUpload
            });
            break;
        case studentRollActions.ADD_STUDENT_SUCCESS:
            trackSchoolRollEvent(track, ANALYTICS_EVENTS.actionCompleted, {
                action: 'add',
                entity_type: 'student',
                module: ANALYTICS_MODULES.students,
                user_profile_id: action.userProfileId
            });
            break;
        case teacherRollActions.ADD_TEACHER_SUCCESS:
            trackSchoolRollEvent(track, ANALYTICS_EVENTS.actionCompleted, {
                action: 'invite',
                entity_type: 'teacher',
                module: ANALYTICS_MODULES.teachers,
                user_profile_id: action.userProfileId
            });
            break;
        case editStudentActions.EDIT_STUDENT_SUCCESS_REQUEST:
            trackSchoolRollEvent(track, ANALYTICS_EVENTS.actionCompleted, {
                action: 'edit',
                entity_type: 'student',
                module: ANALYTICS_MODULES.students
            });
            break;
        case editTeacherActions.EDIT_TEACHER_SUCCESS_REQUEST:
            trackSchoolRollEvent(track, ANALYTICS_EVENTS.actionCompleted, {
                action: 'edit',
                entity_type: 'teacher',
                module: ANALYTICS_MODULES.teachers
            });
            break;
        case assignUserActions.ASSIGN_STUDENT_SUCCESS:
            trackSchoolRollEvent(track, ANALYTICS_EVENTS.actionCompleted, {
                action: 'assign_class',
                entity_type: 'student',
                module: ANALYTICS_MODULES.students
            });
            break;
        case assignUserActions.ASSIGN_TEACHER_SUCCESS:
        case assignUserActions.ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS:
            trackSchoolRollEvent(track, ANALYTICS_EVENTS.actionCompleted, {
                action: 'assign_class',
                entity_type: 'teacher',
                module: ANALYTICS_MODULES.teachers
            });
            break;
        case manageDefaultCourseActions.SAVE_DEFAULT_COURSE_SUCCESS:
            trackSchoolRollEvent(track, ANALYTICS_EVENTS.actionCompleted, {
                action: 'save',
                module: ANALYTICS_MODULES.manageDefaultCourses
            });
            break;
        case manageAssignedCourseActionTypes.ASSIGN_COURSES_SUCCESS:
            trackSchoolRollEvent(track, ANALYTICS_EVENTS.actionCompleted, {
                action: 'save',
                module: ANALYTICS_MODULES.manageAssignedCourses
            });
            break;
        case rollOverActions.ON_ROLLOVER_CONFIRMATION_SUCCESS:
            trackSchoolRollEvent(track, ANALYTICS_EVENTS.actionCompleted, {
                action: 'rollover',
                module: ANALYTICS_MODULES.rollover,
                rollover_type: lastRolloverType
            });
            lastRolloverType = '';
            break;
        default:
            break;
        }

        return result;
    };
}



// WEBPACK FOOTER //
// ./app/analytics/middleware.js